<template>
	<div>
		<LightboxBase class="about" :close="close">
			<div class="about__column about__column--left">
				<h2>ART KINA</h2>

				<p>Máte rádi klidná a přátelská kina místo přeplněných multiplexů? Preferujete pivo či víno před popkornem s količkou? Pak takhle praktická věc nesmí chybět ve vašem mobilu či tabletu.</p>
				<p>V aplikaci naleznete jak informace o promítání a ceně, tak detailní popisy filmů. Nechcete si nechat ujít konkrétní film? Notifikace vám projekci jednoduše připomene.</p>

				<p>Vyhledávat můžete v programu art kin těchto 4 měst: Praha, Brno, Ostrava, Hradec Králové.</p>

				<h4>KE STAŽENÍ ZDARMA</h4>
				<ul class="downloads">
					<li><a href="http://bit.ly/aiosweb" class="appstore" target="_blank">App Store</a></li>
					<li><a href="http://bit.ly/akgpweb" class="googleplay" target="_blank">Google Play</a></li>
				</ul>
			</div>

			<div class="about__column about__column--right">
				<h3>Artkina Ukovali</h3>

				<h4>Jan Blaško</h4>
				<p>Luke Skywalker projektu Artkina.cz. Krom toho zapálený vývojář žijící v Sydney, milovník Aronofského, komiksů a dobrýho kafe.<br>
				<a href="http://144.wtf" target="_blank">144.wtf</a></p>

				<h4>GoodShape</h4>
				<p>Kreativní internetová agentura. Vytváříme webové prezentace, mobilní aplikace a online marketingové strategie. Klademe velký důraz na design produktu a precizní provedení.<br>
				<a href="http://www.goodshape.cz" target="_blank">www.goodshape.cz</a></p>
				<p class="copyright">&copy; {{ date }} Jan Blaško, GoodShape s.r.o.</p>
			</div>
		</LightboxBase>
	</div>
</template>

<script>
import LightboxBase from './LightboxBase.vue'

export default {
	components: { LightboxBase },
	computed: {
		date: () => new Date().getFullYear(),
		close: () => () => {
			document.querySelector('html').classList.remove('lightbox--active')
			document.querySelector('html').classList.remove('lightbox--active-about')
		}
	},
	methods: {}
}
</script>

<style lang=less>
	@import "../../assets/less/default.less";

	html.lightbox--active.lightbox--active-about {
		#lightbox.about { max-width: 100%; max-height: 100%; }
	}
	#lightbox.about {
		.lightbox__content {
			@media @mobile { width: 90vw; margin-top: 1em; }
		}
		.lightbox__wrapper--inner { display: flex; flex-direction: row;
		 	@media @tablet { background: transparent url('../../assets/images/bg-iphone.png') left 100% bottom -10px no-repeat; background-size: 35%; }
			@media @tablet { flex-direction: column; }
			@media @mobile { flex-direction: column; }
			.about__column { padding: 1rem 2rem;
				@media @mobile { padding: 1rem; }
				&--left { width: 75%; padding-right: 30%; background: transparent url('../../assets/images/bg-iphone.png') left 100% bottom -20px / contain no-repeat;
					@media @desktop { width: 99%; padding-right: 35%; }
					@media @tablet, @mobile { width: 100%; padding-right: 2rem; background: none; }
				}
				&--right { width: 25%; padding-left: 0; text-align: center;
					@media @desktop { display: none; }
					@media @tablet, @mobile { width: 100%; text-align: left; padding-left: 2rem; padding-right: 40%; }
					@media @mobile { padding-right: 2rem; }
				}
			}
			h2 { font-size: 4rem;
				@media @mobile { font-size: 3rem; }
			}
			h3 { font-size: 1.8rem; margin: 0.5rem 0; color: @red; }
			h4 { font-size: 1.4rem; margin: 1rem 0 .5rem; }
			p { margin: 0.5rem 0; }
			p a { color: @redDark; }
			h4 + p { margin-top: 0; }
			.copyright { margin-top: 1rem; font-size: 0.8rem; }
			ul.downloads {
				@media @mobile {
					li { list-style: circle; margin-left: 2em; }
					a { color: white; }
				}
				@media @tablet, @desktop, @desktop-xl {
					position: relative; .size(370px, 110px); background: transparent url('../../assets/images/bg-download.png') 0 0 no-repeat;
					a { display: block; .size(123px,100px); padding: 1rem; color: white; font-size: 1.5rem; line-height: 2rem; font-weight: 300;
						&.appstore { .top-left(5px, 115px);
							&:hover { background: transparent url('../../assets/images/bg-download.png') -115px -236px no-repeat; }
						}
						&.googleplay { .top-left(5px, 238px); .size(134px, 100px);
							&:hover { background: transparent url('../../assets/images/bg-download.png') -238px -119px no-repeat; }
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lightbox/LightboxAbout.vue